import { FC } from 'react';

import classNames from 'classnames';
import styles from './business-hub-list-e-commerce.module.scss';
import E_CommerceItem from './e-commerce-item/e-commerce-item';

export enum ALIGHT_ITEMS_TITLE {
    center = 'Center',
    start = 'Start',
    end = 'End',
}

export enum BACKGROUND_CONTENT {
    default = 'default',
    gray = 'gray',
}

export type E_CommerceProps = {
    background?: {
        backgroundColor?: string;
        backgroundImage?: string;
    };

    content?: {
        title?: string;
        alignItemsTitle?: ALIGHT_ITEMS_TITLE;
        maxWidthTitle?: number;
        positionPartner?: ALIGHT_ITEMS_TITLE;
        items?: {
            image?: string;
            linkPartner?: string;
            ratio?: number;
            maxWidth?: number;
            maxHeight?: number;
            filterGrayScale?: boolean;
        }[];
        paddingContent?: number;
        borderItem?: boolean;
        backgroundItem?: string;
        // backgroundContent?: BACKGROUND_CONTENT;
        backgroundContent?: string;
    };
};

const BusinessHubListE_Commerce: FC<E_CommerceProps> = (props) => {
    const { background, content } = props;

    // const backgroundContent = content?.backgroundContent === 'gray' ? styles.bgGray : styles.default;

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: background?.backgroundColor,
            }}
        >
            <div className={styles.backgroundImage}>
                <img src={background?.backgroundImage} alt="" />
            </div>

            <div
                className={classNames(styles.content)}
                style={
                    {
                        paddingTop: content?.paddingContent,
                        paddingBottom: content?.paddingContent,
                        ['--alignItemsTitle']: content?.alignItemsTitle,
                        backgroundColor: content?.backgroundContent,
                    } as React.CSSProperties
                }
            >
                <div className={styles.wrapper}>
                    <div
                        className={styles.title}
                        style={
                            {
                                maxWidth: content?.maxWidthTitle,
                            } as React.CSSProperties
                        }
                    >
                        <span dangerouslySetInnerHTML={{ __html: content?.title || '' }}></span>
                    </div>
                    <div
                        className={styles.wrapperItems}
                        style={
                            {
                                ['--positionPartner']: content?.positionPartner,
                            } as React.CSSProperties
                        }
                    >
                        <div className={styles.items}>
                            {content?.items?.map((item, index) => (
                                <div className={styles.item} key={index}>
                                    <E_CommerceItem
                                        image={item.image}
                                        borderItem={content.borderItem}
                                        backgroundItem={content.backgroundItem}
                                        linkPartner={item.linkPartner}
                                        ratio={item.ratio}
                                        maxHeight={item.maxHeight}
                                        maxWidth={item.maxWidth}
                                        filterGrayScale={item.filterGrayScale}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessHubListE_Commerce;
